import Head from "next/head";
import { DefaultSeo } from "next-seo";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

import getSEOConfig from "../../next-seo.config";
import ModalPortal from "components/ModalPortal";

import 'styles/tailwind.globals.css';
import 'styles/normalize.sass'
import 'styles/checkout/index.sass'
import "../../../common/styles/animations.css";


 // Check that PostHog is client-side (used to handle Next.js SSR)
 if (typeof window !== "undefined") {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host:
      process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://app.posthog.com",
    // Enable debug mode in development
    loaded: (posthog) => {
      console.log("Posthog loaded successfully");
      if (process.env.NODE_ENV === "development") posthog.debug();
    },
  });
}

function MyApp({ Component, pageProps }) {
  const SEOConfig = getSEOConfig();

  const router = useRouter();

  useEffect(() => {
    // Track page views
    const handleRouteChange = () => posthog?.capture("$pageview");
    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, []);

  return (
    <>
      <Head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, shrink-to-fit=no" />
      </Head>
      {
        SEOConfig && <DefaultSeo {...SEOConfig} />
      }
      <PostHogProvider client={posthog}>
        <Component {...pageProps} />
      </PostHogProvider>
      <ModalPortal />
      <Toaster />
    </>
  );
}

export default MyApp
